export class StartSqlQueryExecutionInput {
    'sqlEngineId';
    'query';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sqlEngineId",
            "baseName": "sqlEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartSqlQueryExecutionInput.attributeTypeMap;
    }
    constructor() {
    }
}
